/* ============================================================
   Verdi theme
   Nav state, scroll reveals, product gallery, colour swatches,
   quantity rules, and AJAX cart add / update.
   ============================================================ */
(function () {
  "use strict";

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var routes = (window.Verdi && window.Verdi.routes) || {};

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = (window.Verdi && window.Verdi.moneyFormat) || "${{amount}}";
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, "");
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = document.getElementById("toast");
    if (!el) return;
    el.textContent = msg;
    el.classList.add("on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove("on"); }, 3000);
  }

  /* ---------- nav hairline ---------- */
  var nav = document.getElementById("nav");
  if (nav) {
    var navState = function () { nav.classList.toggle("stuck", window.scrollY > 8); };
    navState();
    window.addEventListener("scroll", navState, { passive: true });
  }

  /* ---------- scroll reveals ---------- */
  var revealables = document.querySelectorAll(".rv");
  if (reduced || !("IntersectionObserver" in window)) {
    revealables.forEach(function (el) { el.classList.add("in"); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -10% 0px", threshold: 0.08 });
    revealables.forEach(function (el) { io.observe(el); });
  }

  /* ---------- cart badge ---------- */
  function paintCount(n) {
    var el = document.getElementById("cartCount");
    if (!el) return;
    el.textContent = String(n);
    el.classList.toggle("on", n > 0);
  }

  function refreshCart() {
    return fetch(routes.cart + ".js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paintCount(c.item_count); return c; });
  }

  /* ---------- quick add from product cards ---------- */
  document.querySelectorAll("form[data-quick-add]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector("button");
      var label = btn.textContent;
      btn.disabled = true;

      fetch(routes.cart_add, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: parseInt(form.querySelector('[name="quantity"]').value, 10) || 1
        })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { toast(res.d.description || "Could not add that"); return; }
          btn.textContent = "Added";
          btn.classList.add("done");
          toast(res.d.product_title + " added");
          setTimeout(function () { btn.textContent = label; btn.classList.remove("done"); }, 1400);
          return refreshCart();
        })
        .catch(function () { toast("Could not add that — try again"); })
        .finally(function () { btn.disabled = false; });
    });
  });

  /* ---------- product page ---------- */
  var pForm = document.getElementById("productForm");
  if (pForm) {
    var variantsEl = document.getElementById("variantData");
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var addBtn = document.getElementById("addBtn");
    var qtyOut = document.getElementById("qtyValue");
    var qtyIn = document.getElementById("qtyInput");
    var lineTotal = document.getElementById("lineTotal");
    var lo = parseInt(addBtn.dataset.min, 10) || 1;
    var hi = parseInt(addBtn.dataset.max, 10) || 99;
    var qty = parseInt(qtyIn.value, 10) || lo;
    var selected = {};

    /* seed the selected options from the current variant */
    var currentId = pForm.querySelector("[data-variant-id]").value;
    variants.forEach(function (v) {
      if (String(v.id) === String(currentId)) {
        selected[1] = v.option1; selected[2] = v.option2; selected[3] = v.option3;
      }
    });

    function currentVariant() {
      return variants.filter(function (v) {
        return (!selected[1] || v.option1 === selected[1]) &&
               (!selected[2] || v.option2 === selected[2]) &&
               (!selected[3] || v.option3 === selected[3]);
      })[0];
    }

    function paintQty() {
      qtyOut.textContent = String(qty);
      qtyIn.value = String(qty);
      document.getElementById("qtyDown").disabled = qty <= lo;
      document.getElementById("qtyUp").disabled = qty >= hi;
      document.querySelectorAll(".pick").forEach(function (b) {
        b.setAttribute("aria-pressed", String(parseInt(b.dataset.n, 10) === qty));
      });
      if (lineTotal) {
        var unitPrice = parseInt(lineTotal.dataset.unitPrice, 10) || 0;
        lineTotal.textContent = qty + " · " + money(unitPrice * qty);
      }
    }

    function paintVariant() {
      var v = currentVariant();
      if (!v) return;
      pForm.querySelector("[data-variant-id]").value = v.id;

      var priceEl = pForm.parentElement.querySelector("[data-price]");
      if (priceEl) priceEl.textContent = money(v.price);
      var cmp = pForm.parentElement.querySelector("[data-compare]");
      if (cmp) cmp.style.display = (v.compare_at_price > v.price) ? "" : "none";
      if (cmp && v.compare_at_price > v.price) cmp.textContent = money(v.compare_at_price);
      var save = pForm.parentElement.querySelector("[data-save]");
      if (save) {
        if (v.compare_at_price > v.price) {
          save.style.display = ""; save.textContent = "Save " + money(v.compare_at_price - v.price);
        } else { save.style.display = "none"; }
      }

      var stock = pForm.querySelector("[data-stock]");
      if (stock) {
        stock.className = v.available ? "stock" : "stock out";
        stock.textContent = v.available
          ? "In stock — ships in 1–3 days, arrives in 15–30"
          : "Sold out";
      }
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? "Add to cart" : "Sold out";

      if (lineTotal) { lineTotal.dataset.unitPrice = v.price; paintQty(); }

      /* swap the main image to the variant's own image if it has one */
      if (v.featured_image && v.featured_image.src) {
        var main = document.getElementById("pdpImage");
        if (main) main.src = v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, "$1?width=1200");
      }
    }

    document.getElementById("qtyDown").addEventListener("click", function () {
      if (qty > lo) { qty--; paintQty(); }
    });
    document.getElementById("qtyUp").addEventListener("click", function () {
      if (qty < hi) { qty++; paintQty(); }
    });
    document.querySelectorAll(".pick").forEach(function (b) {
      b.addEventListener("click", function () { qty = parseInt(b.dataset.n, 10); paintQty(); });
    });

    document.querySelectorAll(".swatch").forEach(function (s) {
      s.addEventListener("click", function () {
        var pos = parseInt(s.dataset.optionPosition, 10);
        selected[pos] = s.dataset.optionValue;
        document.querySelectorAll('.swatch[data-option-position="' + pos + '"]').forEach(function (o) {
          o.setAttribute("aria-pressed", String(o === s));
        });
        var chosen = document.getElementById("colourChosen");
        if (chosen) chosen.textContent = s.dataset.optionValue;
        paintVariant();
      });
    });

    document.querySelectorAll(".pdp-thumb").forEach(function (t) {
      t.addEventListener("click", function () {
        document.querySelectorAll(".pdp-thumb").forEach(function (o) {
          o.setAttribute("aria-pressed", String(o === t));
        });
        var main = document.getElementById("pdpImage");
        if (main) main.src = t.dataset.src;
      });
    });

    pForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var label = addBtn.textContent;
      addBtn.disabled = true;
      fetch(routes.cart_add, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({
          id: pForm.querySelector("[data-variant-id]").value,
          quantity: qty
        })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { toast(res.d.description || "Could not add that"); return; }
          addBtn.textContent = "Added";
          toast(res.d.product_title + " ×" + qty + " added");
          setTimeout(function () { addBtn.textContent = label; }, 1400);
          return refreshCart();
        })
        .catch(function () { toast("Could not add that — try again"); })
        .finally(function () { addBtn.disabled = false; });
    });

    paintQty();
  }

  /* ---------- cart page ---------- */
  function changeLine(line, quantity) {
    return fetch(routes.cart_change, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); });
  }

  document.querySelectorAll(".cart-row").forEach(function (row) {
    var line = parseInt(row.dataset.line, 10);
    var out = row.querySelector("output");
    var down = row.querySelector(".qty-down");
    var up = row.querySelector(".qty-up");
    var min = down ? (parseInt(down.dataset.min, 10) || 1) : 1;

    if (down) down.addEventListener("click", function () {
      var n = parseInt(out.textContent, 10) - 1;
      if (n >= min) changeLine(line, n);
    });
    if (up) up.addEventListener("click", function () {
      changeLine(line, parseInt(out.textContent, 10) + 1);
    });
    var rm = row.querySelector(".cart-remove");
    if (rm) rm.addEventListener("click", function () { changeLine(line, 0); });
  });

  /* ---------- film band ---------- */
  var video = document.getElementById("growthVideo");
  var filmToggle = document.getElementById("filmToggle");
  if (video && filmToggle) {
    if (reduced) {
      video.removeAttribute("autoplay");
      video.pause();
      filmToggle.remove();
    } else {
      var PLAY = '<rect x="6" y="5" width="4" height="14" rx="1"></rect><rect x="14" y="5" width="4" height="14" rx="1"></rect>';
      var PAUSED = '<path d="M8 5l11 7-11 7z"></path>';
      var icon = document.getElementById("filmIcon");
      var flabel = document.getElementById("filmLabel");

      var paintFilm = function () {
        var playing = !video.paused;
        if (icon) icon.innerHTML = playing ? PLAY : PAUSED;
        if (flabel) flabel.textContent = playing ? "Pause" : "Play";
        filmToggle.setAttribute("aria-pressed", String(playing));
        filmToggle.setAttribute("aria-label", playing ? "Pause the film" : "Play the film");
      };

      filmToggle.addEventListener("click", function () {
        if (video.paused) video.play(); else video.pause();
        video.dataset.userPaused = video.paused ? "1" : "0";
      });
      video.addEventListener("play", paintFilm);
      video.addEventListener("pause", paintFilm);

      var attempt = video.play();
      if (attempt && typeof attempt.catch === "function") attempt.catch(paintFilm);
      paintFilm();

      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              if (video.dataset.userPaused !== "1") video.play().catch(function () {});
            } else { video.pause(); }
          });
        }, { threshold: 0.15 }).observe(video);
      }
    }
  }
})();
